/**
 * The context types the application could be in.
 * Mouse, keyboard, and pillow speaker interaction should only influence a singular context.
 *
 * @constant
 * @type {Object}
 */
export const APPLICATION_CONTEXTS = {
  QUICK_LINKS: "Quick Links",
  BRANDING: "Branding",
  SERVICES: "Services",
  PATIENT: "Patient",
  THEME: "Theme",
};
